module.exports = __webpack_public_path__ + "static/media/contact.522eb24a.svg";